define('../src/sublayouts/m29-content-pos/m29-content-pos',['jquery'], function ($) {
    'use strict';

    var M29_COPOS = function ($component) {

        this.$component = $component;

        return this;
    };

    M29_COPOS.prototype.init = function () {
        var _this = this;
            _this.$component.css('height',_this.$component.find('.m29-content-pos-wrapper').height())
            
            $(window).on('orientationchange resize', function () {
                _this.$component.css('height',_this.$component.find('.m29-content-pos-wrapper').height())
            });
    };

    return M29_COPOS;

});

